import { RawKey } from '@master/annotation/RawKey'
import { Meta } from '@master/model/common/Meta'

export const header = [
  '_oid',
  'user_oid',
  'username',
  'user_fullname',
  'course_title',
  'course_provider',
  'course_venue',
  'course_description',
  'duration',
  'start_date_millis',
  'end_date_millis',
  'fa_core_ethics_hours',
  'fa_core_reg_hours',
  'fa_supp_ms_hours',
  'fa_supp_others_hours',
  'gi_others',
  'assigned_to',
  'present',
  'course_id'
]

export class UserCPDMeta extends Meta {
  @RawKey('_oid')
  oid = ''

  userOid = ''
  username = ''
  userFullname = ''
  courseTitle = ''
  courseProvider = ''
  courseVenue = ''
  courseDescription = ''
  duration = ''
  startDateMillis: number = undefined
  endDateMillis: number = undefined
  faCoreEthicsHours = 0
  faCoreRegHours = 0
  faSuppMsHours = 0
  faSuppOthersHours = 0
  giOthers = 0
  assignedTo: number = undefined
  present: number = undefined
  courseId = ''

  cloneFrom (data: UserCPDMeta) {
    Object.keys(this).forEach((key) => {
      this[key] = data[key]
    })
  }
}
